import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Autocomplete, TextField } from '@mui/material';

import '../../../scss/Components/_modal.scss';
import customAxios from '../../../utils/customAxios';
import { getToast } from '../../../utils/toastConfig';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

function ModalEUpdate(props) {
  const { notesString } = useTranslationHook();

  var equipNameDefaultU = localStorage.getItem('equipNameForUPlaceholder');
  var equipDescDefaultU = localStorage.getItem(
    'equipDescriptionForUPlaceholder',
  );
  var equipNotesDefaultU = localStorage.getItem('equipNotesForU');
  var equipBusinessUnitDefaultU = localStorage.getItem(
    'equipBusinessUnitForUPlaceholder',
  );

  const [name, setName] = useState(equipNameDefaultU);
  const [description, setDescription] = useState(equipDescDefaultU);
  const [models, setModels] = useState([]);
  const [model, setModel] = useState(null);
  const [businessUnit, setBusinessUnit] = useState(equipBusinessUnitDefaultU);
  const [notes, setNotes] = useState(equipNotesDefaultU);

  useEffect(() => {
    if (!props.show) return;
    customAxios
      .get(`${GlobalVariables.getURL()}models/`, HEADERS)
      .then((response) => {
        const loadedModels = response.data.data || response.data || [];
        setModels(loadedModels);
        const modelId = Number(
          localStorage.getItem('equipModelIdForUPlaceholder'),
        );
        setModel(loadedModels.find((item) => item.id === modelId) || null);
      })
      .catch((error) => console.log(error));
  }, [props.show]);

  const resetFormFields = () => {
    setName(localStorage.getItem('equipNameForUPlaceholder'));
    setDescription(localStorage.getItem('equipDescriptionForUPlaceholder'));
    setBusinessUnit(localStorage.getItem('equipBusinessUnitForUPlaceholder'));
    setNotes(localStorage.getItem('equipNotesForU'));
  };

  function updateEquip(event) {
    event.preventDefault();
    if (!model) return;
    var updateEquipId = localStorage.getItem('equipIdForUpdate');
    customAxios
      .patch(
        `${GlobalVariables.getURL()}updateEquip/${updateEquipId}`,
        {
          // url to POST
          equip_name: name,
          description: description,
          model_id: model.id,
          business_unit: businessUnit,
          notes,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        },
      )
      .then(
        (response) => {
          console.log(response);
          hide();
        },
        (error) => {
          getToast({
            status: 'error',
            title: 'Error al actualizar tipo de equipo. Vuelve a intentarlo.',
          });
          console.log(error);
        },
      );
  }

  function hide() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Tipo de equipo actualizado exitosamente en la base de datos.',
    });
    props.getEquips();
  }

  return (
    <Modal
      onEntering={resetFormFields}
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar tipo de equipo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="update-equip-form" onSubmit={updateEquip}>
          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Nombre del tipo de equipo"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                multiline
                sx={{ width: '100%' }}
                label="Descripción"
                rows={4}
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <Autocomplete
                sx={{ width: '100%' }}
                options={models}
                value={model}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) =>
                  option.brand_name
                    ? `${option.name} (${option.brand_name})`
                    : option.name || ''
                }
                onChange={(event, newValue) => setModel(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Modelo" required />
                )}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Unidad de Negocio"
                type="text"
                value={businessUnit}
                onChange={(e) => setBusinessUnit(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label={notesString}
                type={'text'}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          form="update-equip-form"
          className="update-modal-button"
          disabled={!model}
        >
          Guardar cambios
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalEUpdate;
